import React from 'react';
import { Loader as WSCLoader } from '@trackman/web-shared-components';
import { LoaderWrapper } from './styles/LoaderStyles';

interface IProps {
  size?: 'small' | 'large' | undefined;
  disableShrink?: boolean | undefined;
  center?: boolean;
}

const Loader: React.FC<IProps> = (props) => {
  const { center } = props;

  return (
    <LoaderWrapper centered={center}>
      <WSCLoader {...props} />
    </LoaderWrapper>
  );
};

export default Loader;
